import type { PropsWithChildren } from 'react'
import { isDebug } from '@/config'

//Only renders the children of this component if the build mode is development
export const DebugOnly = (props: PropsWithChildren) => {
  if (isDebug) return props.children
}
